import { ALLOWED_SPIFF_EVENTS, getSpiffEventName } from "./constants";

const DEFAULT_ACTIVITY_FEED_PAGE_SIZE = 50;

export interface ActivityFeedQueryFilters {
  myActivity?: boolean;
  selectedFilters?: string[];
  search?: string;
  showUnattributedReviews?: boolean;
  pageSize?: number;
}

export interface NormalizedActivityFeedQueryFilters {
  myActivity: boolean;
  selectedFilters: string[];
  search: string;
  showUnattributedReviews: boolean;
  pageSize: number;
}

export const normalizeActivityFeedQueryFilters = (
  filters: ActivityFeedQueryFilters = {},
): NormalizedActivityFeedQueryFilters => {
  const selectedFilters = Array.from(
    new Set(
      (filters.selectedFilters ?? [])
        .map((eventName) => getSpiffEventName(eventName))
        .filter((eventName) => ALLOWED_SPIFF_EVENTS.has(eventName)),
    ),
  ).sort();

  return {
    myActivity: filters.myActivity ?? false,
    selectedFilters,
    search: filters.search?.trim() ?? "",
    showUnattributedReviews: filters.showUnattributedReviews ?? false,
    pageSize: filters.pageSize ?? DEFAULT_ACTIVITY_FEED_PAGE_SIZE,
  };
};
